import { EquityCompensationAssetDTO } from '../../../../../../api/useEstatePlanningExplanationQuery';
import { Beneficiaries } from '../../EditAssetForm.meta';

export interface FormValues extends EquityCompensationAssetDTO {}

export interface Body {
  Id: string;
  IncludedInEstatePlan: number;
  Beneficiaries: Beneficiaries;
}

export const formToBody = (values: FormValues): Body => {
  const {
    Id,
    IncludedInEstatePlan,
    ContingentBeneficiaries,
    PrimaryBeneficiaries,
    LastUpdated,
  } = values;

  return {
    Id,
    IncludedInEstatePlan,
    Beneficiaries: {
      ContingentBeneficiaries: ContingentBeneficiaries || [],
      PrimaryBeneficiaries: PrimaryBeneficiaries || [],
      LastBeneficiaryUpdate: LastUpdated,
    },
  };
};

export const EQUITY_COMPENSATION_ASSET_FORM_ID = 'equity--compensation--asset--form';
